module.exports = __webpack_public_path__ + "media/application/images/demsoc/tiles/polychrome_2-446188155b4a17816272d9f58860ec4c.jpg";